/**
 * New header menu: brand-tab switching and the page dim behind an open mega panel.
 * Loaded only when the header Layout setting is New.
 */
(function () {
  var CLOSE_DELAY = 90;

  function headerSection() {
    return document.querySelector('.section-header');
  }

  function ensureBackdrop() {
    var container = headerSection() || document.body;
    var backdrop = container.querySelector(':scope > .c-mega-backdrop');

    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'c-mega-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      container.insertBefore(backdrop, container.firstChild);
    }

    return backdrop;
  }

  function removeBackdrop() {
    document.querySelectorAll('.c-mega-backdrop').forEach(function (node) {
      node.remove();
    });
    document.documentElement.classList.remove('c-mega-open');
  }

  function syncBackdrop() {
    if (!document.querySelector('.c-header-menu')) {
      removeBackdrop();
      return;
    }

    var backdrop = ensureBackdrop();
    var open = Boolean(document.querySelector('.c-header-menu__item.is-open'));
    backdrop.classList.toggle('is-active', open);
    backdrop.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('c-mega-open', open);
  }

  function closeItem(item) {
    item.classList.remove('is-open');
    var link = item.querySelector('.c-header-menu__link');
    if (link) link.setAttribute('aria-expanded', 'false');
  }

  function openItem(item) {
    var menu = item.closest('.c-header-menu');
    if (menu) {
      menu.querySelectorAll('.c-header-menu__item.is-open').forEach(function (open) {
        if (open !== item) closeItem(open);
      });
    }

    item.classList.add('is-open');
    var link = item.querySelector('.c-header-menu__link');
    if (link) link.setAttribute('aria-expanded', 'true');
    syncBackdrop();
  }

  function bindMenuItem(item) {
    if (item.dataset.cHeaderMenuReady === 'true') return;
    item.dataset.cHeaderMenuReady = 'true';

    var timer;

    function scheduleClose() {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        closeItem(item);
        syncBackdrop();
      }, CLOSE_DELAY);
    }

    function cancelClose() {
      window.clearTimeout(timer);
    }

    item.addEventListener('pointerenter', function () {
      cancelClose();
      openItem(item);
    });
    item.addEventListener('pointerleave', scheduleClose);
    item.addEventListener('focusin', function () {
      cancelClose();
      openItem(item);
    });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) scheduleClose();
    });
  }

  function activatePanel(tabs, panels, tab) {
    var panelId = tab.dataset.panelId;
    if (!panelId) return;

    tabs.forEach(function (item) {
      var active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var active = panel.id === panelId;
      panel.classList.toggle('is-active', active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  }

  function initMegaTabs(mega) {
    if (mega.dataset.cMegaTabsReady === 'true') return;
    mega.dataset.cMegaTabsReady = 'true';

    var tabs = Array.prototype.slice.call(mega.querySelectorAll('[data-c-mega-tab]'));
    var panels = Array.prototype.slice.call(mega.querySelectorAll('[data-c-mega-panel]'));
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      function onSelect() {
        activatePanel(tabs, panels, tab);
      }

      tab.addEventListener('pointerenter', onSelect);
      tab.addEventListener('focus', onSelect);
      tab.addEventListener('click', onSelect);
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (!scope.querySelector('.c-header-menu') && scope !== document && !scope.classList.contains('c-header-menu')) {
      if (!document.querySelector('.c-header-menu')) removeBackdrop();
      return;
    }

    scope.querySelectorAll('.c-header-menu__item--mega').forEach(bindMenuItem);
    scope.querySelectorAll('[data-c-mega]').forEach(initMegaTabs);
    syncBackdrop();
  }

  function onKeydown(event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.c-header-menu__item.is-open').forEach(closeItem);
    syncBackdrop();
  }

  if (!document.documentElement.dataset.cHeaderMenuBound) {
    document.documentElement.dataset.cHeaderMenuBound = 'true';
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
